import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';

import './faceLook.scss';

function FaceLook({ coverOnPreview, checkValue, covers, getTemplateNumber }) {
  let [boton, setBoton] = useState(null);
  const [elements, setElements] = useState(covers);
  useEffect(() => {
    activar(coverOnPreview);
  }, [coverOnPreview]);
  //const { key, pathImg, status, evento, item } = props;
  //const [element, setElement] = useState(item.id);

  const handleClick = (element) => {
    activar(element);

    /*       evento(element);
     */
  };

  function activar(id) {
    setBoton({ id: id });
    checkValue(id);
    elements.map((item, index) => {
      if (id == item.id) {
        item = {
          ...item,
          status: true,
          pathImgToggle: '/img/profile/aprobacion.svg',
          class: 'aprobacion-activo',
        };
      } else {
        item = {
          ...item,
          status: false,
          pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
          class: 'aprobacion-inactivo',
        };
      }
      elements[index] = item;
    });
    setElements(elements);
  }

  function desactivar() {
    setBoton(null);
    elements.map((item, index) => {
      item = {
        ...item,
        status: false,
        pathImgToggle: '/img/profile/aprobacion-inactivo.svg',
        class: 'aprobacion-inactivo',
      };
      elements[index] = item;
    });
    setElements(elements);
  }

  return (
    <>
      <Grid container spacing={2}>
        {elements.map((item, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <div
              className="look_Portada-1"
              onClick={() => {
                handleClick(item.id);

                // This only works for cover proposal
                getTemplateNumber && getTemplateNumber(item.templateNumber);
                // This only works for cover proposal
              }}
              style={{ backgroundImage: `url(${item.pathImg})` }}
            >
              <div
                className={
                  item.id === (boton && boton.id)
                    ? 'aprobacion-activo'
                    : 'aprobacion-inactivo'
                }
              />
              {/* <img className={item.class} src={item.pathImgToggle} alt="" /> */}
            </div>
          </Grid>
        ))}
      </Grid>
    </>
  );
}

const mapStateToProps = (state) => ({
  /*  formValues: state.formValues, */
  authClient: state.authClient,
  proposalData: state.proposalsReducer.newProposalData,
  valuesToEdit: state.proposalsReducer.selectedProposal,
  /* imgProfile: state.authClient.imgProfile, */
});

export default connect(mapStateToProps)(FaceLook);
